import type { Package } from '@/models/package'

import { $packages } from './stores'

export const setPackages = ({
  packages,
  force,
}: {
  packages: any[]
  force: boolean
}) => {
  const customer = $packages.get()
  if (!customer) {
    return
  }

  const newPackages: Array<Package> = [...packages]
  if (force) {
    $packages.set(newPackages)
  } else {
    const existingPackages = $packages.get()
    const filteredPackages = newPackages.filter((pack) => {
      return !existingPackages.some(
        (existingPackage) => existingPackage.id === pack.id,
      )
    })
    $packages.set([...existingPackages, ...filteredPackages])
  }
}
